import ModalDetails from "./ModalDetails";
export default ModalDetails;
